import { ApiUrls } from '@api/apiUrls';
import { fetchApi } from 'api/fetchApi';
import type { FetchApiResponse } from 'api/fetchApi';
import type { IApiAccountSignInRequest, IApiAccountSignInResponse } from 'api/interfaces/data-contracts';
import { ENUM_LOCALE_CODE } from 'global.enums';
import type { IOnboardingConfiguration, IUser, IUserDocument, IUserProfile } from 'global.interfaces';
import type {
  IApiUserAccountPasswordRecovery,
  ISessionExpirationInformation,
  IApiUserAccountOtpRequestResponse,
  IApiUserIpInfo,
} from './account.apiService.interface';

export const apiUserAccountService = {
  signIn: async (data: IApiAccountSignInRequest): Promise<FetchApiResponse<IApiAccountSignInResponse>> => {
    return await fetchApi.post<IApiAccountSignInResponse>(ApiUrls.account.signIn, data);
  },
  signOut: async () => {
    return await fetchApi.post(ApiUrls.account.signOut);
  },
  getUserSettings: async (params: { isInitialAuth?: boolean }) => {
    return await fetchApi.get<IUser>(ApiUrls.account.getUserSettings, {
      params: { initialAuth: params.isInitialAuth },
    });
  },
  getOnboardingConfiguration: async () => {
    return await fetchApi.get<IOnboardingConfiguration>(ApiUrls.onboardingConfigurationUser.get);
  },
  getUserProfile: async () => {
    return await fetchApi.get<IUserProfile>(ApiUrls.user.get);
  },
  getUserDocuments: async (params: { skip: number; take: number }) => {
    return await fetchApi.get<{ records: IUserDocument[] }>(ApiUrls.userDocument.getAll, {
      params,
    });
  },
  getAuthCookieExpirationDate: async () => {
    return await fetchApi.get<ISessionExpirationInformation>(ApiUrls.account.getSessionExpirationInformation);
  },
  setLanguage: async (language: string) => {
    return await fetchApi.post<{ culture: ENUM_LOCALE_CODE }>(
      ApiUrls.culture.setCulture,
      {},
      { params: { name: language } },
    );
  },
  passwordRecovery: async (data: IApiUserAccountPasswordRecovery) => {
    return await fetchApi.post<void>(ApiUrls.account.passwordRecovery, data);
  },
  requestOtp: async (data: IApiAccountSignInRequest): Promise<FetchApiResponse<IApiUserAccountOtpRequestResponse>> => {
    return await fetchApi.post(ApiUrls.account.requestOtp, data);
  },
  updateLanguage: async (language: string) => {
    return await fetchApi.post(ApiUrls.user.updateLanguage, { language });
  },
  getUserIpInfo: async () => {
    return await fetchApi.get<IApiUserIpInfo>(ApiUrls.account.getIpInfo);
  },
};
